import { useState, useEffect} from 'react';
import { Button, TextField, Grid, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import SectionHeader from './SectionHeader';
import EditIcon from '@mui/icons-material/Edit';
import UndoIcon from '@mui/icons-material/Undo';
import Chip from '@mui/material/Chip';
import IconButton from '@mui/material/IconButton';
import CaseUpdateForm from './CaseUpdateForm'
import caseStatusToPill from './CaseStatusPill';
import SendIcon from '@mui/icons-material/Send';
import HailIcon from '@mui/icons-material/Hail';
import CloseIcon from '@mui/icons-material/Close';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import RequestDocsDialogue from './CaseActionDialogues/RequestDocsDialogue'; 
import TransferDialogue from './CaseActionDialogues/TransferDialogue'; 

function CaseInfoPanel(props) { 
  const [showEdit, setShowEdit] = useState(false)
  const [showReject, setShowReject] = useState(false)
  const [showRequestDocs, setShowRequestDocs] = useState(false)
  const [showRetainerSend, setShowRetainerSend] = useState(false)
  const [showTransfer, setShowTransfer] = useState(false)

  const caseInfoForm = <CaseUpdateForm 
    handleOnSubmit={props.handleCaseUpdate} 
    handleCaseDestroy={props.handleCaseDestroy}
    setShowEdit={setShowEdit}
    case={props.caseInfo}  
  />
 
  const headerEditButton= showEdit ? 
  <></> :
          <IconButton 
            size='large' 
                color='primary'
            onClick={() => {setShowEdit(true)}}> 
            <EditIcon /> 
          </IconButton> 
  

  const clearDialogueFlags = () => {
    setShowReject(false)
    setShowRetainerSend(false)
    setShowRequestDocs(false)
    setShowTransfer(false)
  }
  
  const getDescriptionForStatus= (status) => {
    if (status == 'RETAINER_SENT') 
      return  'Awaiting client signature on retainer agreement.'
    else if (status == 'INITIAL')
      return 'Awaiting uploading of case documents.'
    else if (status == 'LEGAL_REVIEW')
      return 'Please review ROS and relevant case files. You must decide to retain or reject this client.'
    return ''
  }

  const mappedOutcomeText = (desired_outcome) => {
    if (desired_outcome == 'refund')
      return 'Refund'
    else if (desired_outcome == 'replacement')
      return 'Replacement'
    else 
      return desired_outcome
  }
  
  const makeDialogue = (open, title, description, actionName, actionClass, onAction) => {

           return (<Dialog
            open={open}
            onclose={() => clearDialogueFlags()}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              {title} 
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                {description}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => clearDialogueFlags()}>Cancel</Button>
              <Button color={actionClass} onClick={() => { clearDialogueFlags(); onAction(); }} autofocus>
                {actionName} 
              </Button>
            </DialogActions>
          </Dialog>)
  }
  
  return <>
            {makeDialogue(showReject, 
              "Reject this case?", 
              "Are you sure you want to alert this client you will not be taking their case?", 
              "Reject",
              "error",
              () => props.handleCaseUpdate({ status: "REJECTED" }, () => {}))}

            {makeDialogue(showRetainerSend, 
              "Send Client Retainer", 
              "They will be sent a email asking them to sign your retainer and notified via the app if possible.", 
              "Send Retainer",
              "success",
              () => { props.handleSignClient() }, () => {})}
            <RequestDocsDialogue 
              open={showRequestDocs}
              clear={clearDialogueFlags}
              onAction={(e) => console.log(e)}
            />
            <TransferDialogue
              open={showTransfer}
              clear={clearDialogueFlags}
              onAction={(organization_id) => props.handleCaseTransfer(organization_id)}
            />
            <SectionHeader title={<>General</>} actions={headerEditButton} align='left' size='h5' />
            <Divider />
            <Box sx={{p: 2}}>
              {!props.isLoading &&
                <>
                  {showEdit &&
                    caseInfoForm
                  }
                  {!showEdit &&
                    <>
                      <Box>
                        <Grid container sx={{mt: 0}} spacing={2}>
                         <Grid item xs={6} sx={{mt: 0}}>
                            <Typography sx={{color: 'secondary.main',  fontSize: "14px", fontWeight: 500, mr: 2}} display='inline' >
                              Name 
                            </Typography>
                            <Typography sx={{color: 'secondary.black', fontSize: "14px", fontWeight: 500, mr: 2}} display='inline' >
                            {props.caseInfo.client_info.name}
                            </Typography>
                          </Grid>
                         <Grid item xs={6}>
                            <Typography sx={{color: 'secondary.main', fontSize: "14px", fontWeight: 500, mr: 2}} display='inline' >
                              Joined 
                            </Typography>
                            <Typography sx={{color: 'secondary.black',  fontSize: "14px", fontWeight: 500,mr: 2}} display='inline' >
                              {new Date(props.caseInfo.created_at).toLocaleString()}
                            </Typography>
                          </Grid>
                         <Grid item xs={6} sx={{mt: 0}}>
                            <Typography sx={{color: 'secondary.main',  fontSize: "14px", fontWeight: 500, mr: 2}} display='inline' >
                              Email 
                            </Typography>
                            <Typography sx={{color: 'secondary.black', fontSize: "14px", fontWeight: 500, mr: 2}} display='inline' >
                            {props.caseInfo.client_info.email}
                            </Typography>
                          </Grid>
                         <Grid item xs={6} sx={{mt: 0 }}>
                            <Typography sx={{color: 'secondary.main',  fontSize: "14px", fontWeight: 500, mr: 2}} display='inline' >
                              Phone 
                            </Typography>
                            <Typography sx={{color: 'secondary.black', fontSize: "14px", fontWeight: 500, mr: 2}} display='inline' >
                            {props.caseInfo.client_info.mobile_phone}
                            </Typography>
                          </Grid>
                         {props.caseInfo.vehicle_info &&
                         <>
                           <Grid item xs={6}>
                              <Typography sx={{color: 'secondary.main',  fontSize: "14px", fontWeight: 500,mr: 2}} display='inline' >
                                Vehicle 
                              </Typography>
                              <Typography sx={{color: 'secondary.black',  fontSize: "14px", fontWeight: 500,mr: 2}} display='inline' >
                                {(props.caseInfo.vehicle_info.vehicle_year)} {(props.caseInfo.vehicle_info.vehicle_make)} { (props.caseInfo.vehicle_info.vehicle_model)}
                              </Typography>
                            </Grid>
                           <Grid item xs={6}>
                              <Typography sx={{color: 'secondary.main',  fontSize: "14px", fontWeight: 500,mr: 2}} display='inline' >
                               VIN 
                              </Typography>
                              <Typography sx={{color: 'secondary.black',  fontSize: "14px", fontWeight: 500,mr: 2}} display='inline' >
                                {(props.caseInfo.vehicle_info.vin)}                            </Typography>
                            </Grid>
                          </>
                         }
                         <Grid item xs={6} sx={{mt: 0}}>
                            <Typography sx={{color: 'secondary.main',  fontSize: "14px", fontWeight: 500, mr: 2}} display='inline' >
                              Desired Outcome 
                            </Typography>
                            <Typography sx={{color: 'secondary.black', fontSize: "14px", fontWeight: 700, mr: 2}} display='inline' >
                            {(mappedOutcomeText(props.caseInfo.desired_outcome))}
                            </Typography>
                          </Grid>
                         <Grid item xs={6} sx={{mt: 0}}>
                            <Typography sx={{color: 'secondary.main',  fontSize: "14px", fontWeight: 500, mr: 2}} display='inline' >
                              Demand Opt-In (AB 1755 Applies) 
                            </Typography>
                            <Typography sx={{color: 'secondary.black', fontSize: "14px", fontWeight: 700, mr: 2}} display='inline' >
                            {props.caseInfo.manufacturer_opted_in ? 'Yes' : props.caseInfo.manufacturer_opted_in == false ? 'No' : '???'}
                            </Typography>
                          </Grid>
                        </Grid>
                      </Box>
                      <Divider sx={{m:0, mb: 2, mt: 2}}/>
                            
                      <Box sx={{p: 0}}>
                          <Box sx={{mb: 2}} >
                            <Typography sx={{color: 'secondary.main',fontSize: "14px", fontWeight: 500,  mr: 2}} display='inline' >
                              Case Status 
                            </Typography>
                            {caseStatusToPill(props.caseInfo.status)}
                            <Typography sx={{color: 'secondary.main',fontSize: "14px", fontWeight: 500,  ml: 2}} display='inline' >
                              (Updated {new Date(props.caseInfo.updated_at).toLocaleString()})
                            </Typography>
                          </Box>
                      <Box sx={{mb: 2}}>
                        <Typography sx={{color: 'secondary.main',  fontSize: "14px", fontWeight: 500, mr: 2}} display='inline' >
                          Description 
                        </Typography>
                        
                        <Typography sx={{fontSize: "14px", fontWeight: 500, mr: 2}} display='inline' >
                          {getDescriptionForStatus(props.caseInfo.status)} 
                        </Typography>
                        <br/>
                      </Box>

                        { props.caseInfo.status == 'NEEDS_DOCUMENTATION' &&
                          <>
                            <Button variant='outlined' onClick={() => setShowRequestDocs(true)} color='secondary' sx={{ml: 1}} >
                              <HailIcon sx={{mr:1}}/> Request Docs
                            </Button>
                            <Button onClick={() => setShowReject(true)} variant='outlined' color='error' sx={{ml: 1}} >
                              <CloseIcon sx={{mr:1}}/> Reject 
                            </Button>
                          </>
                        }
                        { props.caseInfo.status == 'LEGAL_REVIEW' &&
                          <>
                            <Button onClick={() => setShowReject(true)} variant='outlined' color='error' >
                              <CloseIcon sx={{mr:1}}/>Reject 
                            </Button>
                            <Button variant='outlined' onClick={() => setShowRequestDocs(true)} color='secondary' sx={{ml: 1}} >
                              <HailIcon sx={{mr:1}}/> Request Docs
                            </Button>
                            <Button onClick={() => setShowRetainerSend(true)} variant='outlined' color='success' sx={{ml: 1}} >
                              <SendIcon sx={{mr:1}}/> Retainer 
                            </Button>
                          </>
                        }
                        { props.caseInfo.status == 'RETAINER_DECLINED' &&
                          <>
                            <Button onClick={() => setShowRetainerSend(true)} variant='outlined' color='success' sx={{ml: 1}} >
                              <SendIcon sx={{mr:1}}/> Re-Send Retainer 
                            </Button>
                          </>
                        }
                        { props.caseInfo.status == 'DEMAND_PENDING' &&
                          <> 
                            <h4>Legal Review Actions</h4>
                            <Button variant='outlined' color='error' >
                              <CloseIcon sx={{mr:1}}/>Terminate Client 
                            </Button>
                            <Button variant='outlined' color='success' sx={{m: 1}} >
                              <SendIcon sx={{mr:1}}/> Demand 
                            </Button>
                          </>
                        }
                        { props.caseInfo.status == 'LEGAL_REVIEW_PRELAWSUIT' &&
                          <>
                            <h4>Legal Review Actions</h4>
                            <Button variant='outlined' color='error' >
                              <CloseIcon sx={{mr:1}}/>
                            </Button>
                            <Button variant='outlined' color='success' sx={{m: 1}} >
                              <SendIcon sx={{mr:1}}/>Send Complaint 
                            </Button>
                          </>
                        }
                        { props.caseInfo.status == 'RETAINER_SENT' &&
                          <>
                            <Button variant='outlined' color='error' >
                              <CloseIcon sx={{mr:1}}/>Revoke Retainer
                            </Button>
                          </>
                        }
                        <Button onClick={() => setShowTransfer(true)} variant='outlined' color='success' sx={{ml: 1}} >
                          <CompareArrowsIcon sx={{mr:1}}/>Transfer 
                        </Button>
                      </Box>
                    </>
                  }
                </>
              }
            </Box>
  </>
}
export default CaseInfoPanel;
